import { slugify } from "@ckgo2/shared/utils";

/**
 * Pravidlo slugu `useEditPage` jako čistá funkce bez Reactu a bez `api` klienta (projekt `admin`
 * běží v `node` bez DOM, hook se v testu vyrenderovat nedá; `editPageRules.test.ts`).
 * Volby sem přicházejí povinně; výchozí hodnoty vznikají v destrukturaci voleb hooku.
 */

/** Slug, který hook zapíše do pole `slug`, nebo `null` (nezapisuje nic). */
export function autoSlugFor(o: {
  generateSlug: boolean;
  isNew: boolean;
  sourceValue: unknown;
}): string | null {
  if (!o.generateSlug || !o.isNew) return null;
  if (typeof o.sourceValue !== "string" || !o.sourceValue) return null;
  return slugify(o.sourceValue);
}
